// let compartment_config = {
// 	// api请求地址
// 	baseUrl: 'https://b2b.juxiekeji.com/',
// 	// 分仓地址
// 	warehouse_host:sessionStorage.getItem("warehouse_host")||'https://b2b.juxiekeji.com',
// 	// 图片域名
// 	imgDomain: 'https://b2b.juxiekeji.com/',
// 	// 前端域名
// 	webDomain: 'https://b2b.juxiekeji.com/',
// 	// 腾讯地图key
//     mpKey: "",
// 	// 客服
//     webSocket: "",
// 	// 本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
//     pingInterval: 1500,
// 	// 客服地址
//     keFuUrl: "",
//     // 是否允许分仓与默认版本之间切换
//     allowVersion_switch:false
// };
let compartment_config = {
	// api请求地址
	baseUrl: 'https://nb2b.huayizhiyao.cn/',
	// 分仓地址
	warehouse_host:sessionStorage.getItem("warehouse_host")||'https://nb2b.huayizhiyao.cn',
	// 图片域名
	imgDomain: 'https://nb2b.huayizhiyao.cn/',
	// 前端域名
	webDomain: 'https://nb2b.huayizhiyao.cn/',
	// 腾讯地图key
    mpKey: "",
	// 客服
    webSocket: "",
	// 本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
    pingInterval: 1500,
	// 客服地址
    keFuUrl: "",
    // 是否允许分仓与默认版本之间切换
    allowVersion_switch:false
};
export default compartment_config;